import { Button } from 'antd';
import { CustomIcon } from '$src/components/CustomIcon';
import { handleBackToRingDashboard } from '$src/utils/handleBack';
import useStores from '$src/hooks/useStores';

import './FreeTrialCanceled.less';

function FreeTrialCanceled() {
  const {
    sessionStore: { isMobile },
  } = useStores();

  return (
    <div className="free-trial-canceled" data-testid="free-trial-canceled">
      <div className="free-trial-canceled-header">
        <div> Virtual Security Guard Trial </div>
        <Button
          size="small"
          type="text"
          shape="circle"
          icon={<CustomIcon type="regular" name="close.svg" className="step-header__icon" />}
          onClick={() => handleBackToRingDashboard(isMobile)}
          data-testid="step-header__back"
        />
      </div>
      <div className="free-trial-canceled-body">
        <div> We’ve cancelled the Virtual Security Guard Trial you requested. </div>
      </div>
      <div className="free-trial-canceled-footer">
        <Button className="stark-button-bordered" type="primary" size="large" onClick={() => handleBackToRingDashboard(isMobile)}>
          Dashboard
        </Button>
      </div>
    </div>
  );
}

export default FreeTrialCanceled;
